<p-table #dt [value]="usersService.users" dataKey="id" [rowHover]="true"
         [rows]="10" [showCurrentPageReport]="true" [loading]="usersService.loadingState === LoadingState.Loading"
         [paginator]="true" currentPageReportTemplate="Zeige {first} bis {last} von {totalRecords} Mitarbeiter:innen"
         [alwaysShowPaginator]="false">
  <ng-template pTemplate="caption">
    <div class="table-header">
      <div class="w-100">
        <p-iconfield>
          <p-inputicon class="pi pi-search"></p-inputicon>
          <input pInputText type="text" placeholder="Suche" class="w-100"/>
        </p-iconfield>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      <th></th>
      <th>Name</th>
      <th>Username</th>
      <th>Email</th>
      <th>Rolle</th>
      <th style="min-width:140px;"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-user>
    <tr class="p-selectable-row">
      <td>
        <app-user-avatar [user]="user"></app-user-avatar>
      </td>
      <td>{{ user.first_name }} {{ user.last_name }}</td>
      <td>{{ user.username }}</td>
      <td>{{ user.email }}</td>
      <td><span class="role role-{{user.role.id}}">{{ user.role.name }}</span></td>
      <td>
        <p-button icon="pi pi-pencil" [rounded]="true" [outlined]="true" (click)="openEdit(user)"></p-button>
        <p-button icon="pi pi-trash" [rounded]="true" severity="danger" [outlined]="true" class="ms-2"
                  (click)="delete($event, user.id)"></p-button>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="4">Keine Mitarbeiter gefunden</td>
    </tr>
  </ng-template>
</p-table>

<div class="d-flex justify-content-end mt-3">
  <p-button icon="pi pi-plus" label="HINZUFÜGEN" (click)="addUserDisplayed = true; createForm.reset()"></p-button>
</div>


<p-dialog [header]="isEdit ? 'Mitarbeiter bearbeiten' : 'Neuer Mitarbeiter'" [(visible)]="addUserDisplayed"
          [modal]="true">
  <div class="container mt-3">
    <form [formGroup]="createForm" autocomplete="off">
      <div class="p-fluid grid">
        <input formControlName="id" type="hidden" pInputText/>
        <div class="field col-12 md:col-6">
          <p-floatlabel>
            <input class="w-100" formControlName="first_name" id="first_name" type="text" pInputText/>
            <label for="first_name">Vorname</label>
          </p-floatlabel>
        </div>
        <div class="field col-12 md:col-6">
          <p-floatlabel>
            <input id="last_name" formControlName="last_name" class="w-100" type="text" pInputText/>
            <label for="last_name">Nachname</label>
          </p-floatlabel>
        </div>

        <div class="field col-12 md:col-6">
          <p-floatlabel>
            <input id="username" formControlName="username" class="w-100" type="text" pInputText/>
            <label for="username">Username *</label>
          </p-floatlabel>
        </div>
        <div class="field col-12 md:col-6">
          <p-floatlabel>
            <input id="email" formControlName="email" class="w-100" type="text" pInputText/>
            <label for="email">E-Mail *</label>
          </p-floatlabel>
        </div>

        <div class="field col-12">
          <p-floatlabel>
            <p-password id="password" inputStyleClass="w-100" class="w-100" appendTo="body" formControlName="password" [toggleMask]="true"></p-password>
            <label for="password">Passwort @if (!isEdit) {
              <span>*</span>
            }</label>
          </p-floatlabel>
        </div>

        <div class="field col-12">
          <p-floatlabel>
            <p-select appendTo="body" class="w-100" [options]="usersService.roles" formControlName="role"
                      optionLabel="name" inputId="role" optionValue="id"
                      [showClear]="true"></p-select>
            <label for="role">Rolle</label>
          </p-floatlabel>
        </div>
      </div>

    </form>
  </div>

  <ng-template pTemplate="footer">
    <p-button icon="pi pi-times" severity="secondary" [outlined]="true"
              (click)="createForm.reset(); addUserDisplayed = false;" label="ABBRECHEN"></p-button>
    <p-button icon="pi pi-save" (click)="save()" [label]="isEdit ? 'SPEICHERN' : 'HINZUFÜGEN'"></p-button>
  </ng-template>
</p-dialog>

<p-confirmpopup></p-confirmpopup>
